import React, { useEffect, useState } from 'react'
import UserHero from '../../userPages/partials/UserHero'
import ListGroup from '../../userPages/partials/ListGroup'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { FaForward } from 'react-icons/fa'
import UserAccount from '../../userPages/partials/UserAccount'
import FormValidation from '../../validators/Formvalidators'
import imgageValidation from "../../validators/Imagevalidators"
import toast from 'react-hot-toast'

export default function UpdateTestimonils () {
    let {id}= useParams()
    
    let [data, setData] = useState({
       _id :"",
        name:"",
        pic:"",
        message:""
    })
   let navigate = useNavigate()
    let [show, setShow]=useState(false)
    let [errorMessage, setErrorMessage]=useState({
      name:"",
      pic:"",
      message:""
    })
  const InputData=(e)=>{
    let name= e.target.name;
    let value =e.target.files? e.target.files[0]:e.target.value;
    if(name ==="name" || name==="pic" || name==="profile" || name === "message"){
     setErrorMessage((old)=>{
      return{
        ...old,
      [name]:e.target.files ?imgageValidation(e): FormValidation(e)
      }
     })
     setData((old)=>{
      return{
        ...old,
        [name]:value
      }
     })
    //  (data);
  }
}


  async function postData(e){
    e.preventDefault()
    let error = Object.values(errorMessage).find((x)=>x?.length > 0)
    if(error){
      setShow(true)
    }
    else{
      
      let newData = [data]
      // (newData);
      
      let item = newData.find((x)=>x.name?.toLowerCase() === data.name.toLowerCase() && x._id !== id)

      if(item){
        setShow(true)
        setErrorMessage((old)=>{
          return{
            ...old,
            "name":"Name is alredy exits!"
          }
        })
      }
      else{
      let formData = new FormData()
      formData.append("_id",data._id)
      formData.append("name",data.name)
      formData.append("pic", data.pic)
      formData.append("message",data.message)
      
      let response = await fetch(`http://34.228.14.188:8000/api/testimonial/${id}`,{
        method:"PUT",
        body:formData
      }
    )
      response = await response.json()
      // (response);
      
      if(response.result ==="Done"){
        toast.success("Update SuccessFully!")
        navigate("/my-account")
      }
      else{
       alert ("Result not Fouond");
        
      }
    }
     
    }

  }

 useEffect(()=>{
    async function getInputData(){
    try {
      let response = await fetch(`http://34.228.14.188:8000/api/testimonial/${id}`,{
        method:"GET",
        headers:{
          "Content-type":"application/json"
      }
      })
      response =await response.json()
      if(response.result==="Done"){
        setData((old)=>{
          return{
            ...old,
            ...response.data,
          }
        })
      }
      else{
        navigate("/my-account")
      }
      
    } catch (error) {
      alert("Error fetching profile:",error)
    }
      
    }
    getInputData()
 },[data.length])
  

  return (
   <>
   <UserHero/>

   <div className="container">
           <div className="container-fluid mt-3">
            <UserAccount/>
               <div className="row">
               <ListGroup/>
                  <div className="col-md-8">
                  <div className="admin-heading">
                  <h3>UPDATE TESTIMONIAL <Link to="/my-account"><FaForward  className='float-end mx-2 ' /></Link> </h3>:
                           
                       </div>
                     <form  onSubmit={postData}>
                     <div className="mb-3 mt-3 ">
                        <label for="exampleFormControlInput1"  className="form-label">Name*</label>
                        <input type="text" name='name' value={data.name} onChange={InputData}  className="form-control" id="exampleFormControlInput1" placeholder="Enter Your Email"/>
                        {show && errorMessage ? <p className='text-danger'>{errorMessage.name}</p>:""}
                      </div>
                      <div className="mb-3">
                        <label for="exampleFormControlInput1" className="form-label">Pic*</label>
                        <input type="file" name='pic'  onChange={InputData}  className="form-control" id="exampleFormControlInput1" placeholder="Enter Your Email"/>
                        {show && errorMessage ? <p className='text-danger'>{errorMessage.pic}</p>:""}
                        
                      </div>
                 
                       <div className="mb-3">
                         <label for="exampleFormControlTextarea1"  className="form-label">Message*</label>
                         <textarea name='message' value={data.message} onChange={InputData}  className="form-control" id="exampleFormControlTextarea1" rows="3" placeholder='Address....'></textarea>
                         {show && errorMessage ? <p className='text-danger'>{errorMessage.message}</p>:""}
                       
                       </div>
                       <div className="admmin-update mb-5">
                           <button className='w-100 btn-primary' type='submit'>UPDATE TESTIMONIAL</button>
                       </div>
                     </form> 
                  </div>
               </div>
           </div>
          </div>
   </>
  )
}
